export default {
  meta: {
    title: '忘记密码'
  },
};
